import React from 'react'
import ForgotPassword from  '../Forgotpass/index'

function ForgotPass() {
    return (
        <div>
            <ForgotPassword />
        </div>
    )
}

export default ForgotPass
